(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["in-app-header"]) return;
  try {
    
  class InAppHeaderComponent extends HTMLElement {
    // 좌측 변형 노출은 CSS(data-active-variant)가 처리한다.
    // JS는 CSS로 못 넣는 값(타이틀 텍스트/아이콘/검색 placeholder)만 data 속성에서 읽어 주입한다.
    static get observedAttributes() {
      return ['data-active-title', 'data-active-search-placeholder', 'data-active-title-icon-url'];
    }

    connectedCallback() {
      this.backButton = this.querySelector('[data-in-app-back]');
      if (this.backButton) {
        this.handleBack = () => {
          if (window.history.length > 1) {
            window.history.back();
            return;
          }

          // 되감을 히스토리가 없다. 인앱이면 앱이 띄운 화면을 닫는다(규약 3.2 close) —
          // 심플 브라우저로 push 된 지면은 첫 페이지라 history.length 가 1이고, 여기서 홈으로
          // 이동하면 나가는 대신 화면이 하나 더 쌓인 채 남는다.
          // PiyonnaApp 은 defer 로 로드되므로 클릭 시점에 읽는다.
          // close 가 false 면 브릿지가 없다는 뜻(일반 브라우저 · 강제 토글)이므로 홈으로 간다.
          const app = window.PiyonnaApp;
          if (app && app.close()) return;

          window.location.href = '/';
        };
        this.backButton.addEventListener('click', this.handleBack);
      }

      this.applyContent();
    }

    disconnectedCallback() {
      if (this.backButton && this.handleBack) {
        this.backButton.removeEventListener('click', this.handleBack);
      }
    }

    attributeChangedCallback() {
      this.applyContent();
    }

    applyContent() {
      const title = this.dataset.activeTitle;
      if (title) {
        const titleText = this.querySelector('[data-in-app-header-title-text]');
        if (titleText) titleText.textContent = title;
        const categoryText = this.querySelector('[data-in-app-header-category-text]');
        if (categoryText) categoryText.textContent = title;
        const backTitle = this.querySelector('[data-in-app-header-back-title]');
        if (backTitle) backTitle.textContent = title;
      }

      const iconUrl = this.dataset.activeTitleIconUrl;
      if (iconUrl) {
        const titleIcon = this.querySelector('[data-in-app-header-title-icon]');
        if (titleIcon) {
          titleIcon.src = iconUrl;
          titleIcon.hidden = false;
        }
      }

      const placeholder = this.dataset.activeSearchPlaceholder;
      if (placeholder) {
        const searchInput = this.querySelector('[data-in-app-header-search-placeholder]');
        if (searchInput) searchInput.setAttribute('placeholder', placeholder);
      }
    }
  }

  if (typeof customElements.get('in-app-header-component') === 'undefined') {
    customElements.define('in-app-header-component', InAppHeaderComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notifications-in-app"]) return;
  try {
    
  class NotificationsInApp extends HTMLElement {
    connectedCallback() {
      this.permissionCard = this.querySelector('[data-notifications-permission-card]');
      this.requestButton = this.querySelector('[data-notifications-request-permission]');
      this.toggles = Array.from(this.querySelectorAll('[data-notifications-push-toggle]'));

      // app-bridge.js 는 defer 라 이 스크립트보다 늦을 수 있다 — 없으면 파싱이 끝난 뒤 다시 본다
      if (window.PiyonnaApp) {
        this.init();
      } else {
        this.handleReady = () => this.init();
        document.addEventListener('DOMContentLoaded', this.handleReady, { once: true });
      }
    }

    init() {
      const app = window.PiyonnaApp;
      if (!app || this.initialized) return;
      this.initialized = true;

      // 주입값이 없으면 인앱 아님 · 구버전 앱 — 카드 숨김 · 토글 비활성인 채로 끝낸다
      const notification = app.notification();
      if (!notification) return;

      this.render(notification);

      this.handleToggle = (event) => {
        const toggle = event.currentTarget;
        if (toggle.getAttribute('aria-disabled') === 'true') return;

        const category = toggle.dataset.notificationsPushToggle;
        const enabled = toggle.getAttribute('aria-checked') !== 'true';

        // 낙관적 갱신 — OS 권한은 건드리지 않는다(규약 3.13)
        toggle.setAttribute('aria-checked', String(enabled));
        app.setPushSubscription(category, enabled);
      };
      this.toggles.forEach((toggle) => toggle.addEventListener('click', this.handleToggle));

      // 결과는 돌려받지 않는다 — 권한이 바뀌면 onNotificationChange 로 온다(규약 3.9)
      this.handleRequest = () => app.requestAppNotification();
      this.requestButton?.addEventListener('click', this.handleRequest);

      // setPushSubscription 저장 · 바텀시트 · 시스템 팝업 · OS 설정 복귀 — 진입 때와 같은 렌더 함수로 받는다
      this.unsubscribe = app.onNotificationChange((next) => this.render(next));
    }

    render(notification) {
      if (this.permissionCard) this.permissionCard.hidden = notification.permission === 'agree';

      this.toggles.forEach((toggle) => {
        const category = toggle.dataset.notificationsPushToggle;
        // 키가 없으면 미응답 — OFF 로 그린다(규약 3.13)
        toggle.setAttribute('aria-checked', String(notification.pushSubscription[category] === true));
        toggle.removeAttribute('aria-disabled');
      });
    }

    disconnectedCallback() {
      if (this.handleReady) document.removeEventListener('DOMContentLoaded', this.handleReady);
      this.toggles?.forEach((toggle) => toggle.removeEventListener('click', this.handleToggle));
      this.requestButton?.removeEventListener('click', this.handleRequest);
      this.unsubscribe?.();
    }
  }

  if (!customElements.get('notifications-in-app')) {
    customElements.define('notifications-in-app', NotificationsInApp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-blog-article-list"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaBlogArticleListComponent extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-blog-grid]');
      this.sentinel = this.querySelector('[data-sentinel]');
      this.loader = this.querySelector('[data-loader]');

      const nextLink = this.querySelector('[data-next-url]');
      this.nextUrl = nextLink ? nextLink.getAttribute('href') : null;
      this.isLoading = false;

      if (!this.grid || !this.sentinel || !this.nextUrl) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.loadNext();
          });
        },
        { rootMargin: '400px 0px' }
      );
      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async loadNext() {
      if (this.isLoading || !this.nextUrl) return;
      this.isLoading = true;
      if (this.loader) this.loader.hidden = false;

      try {
        const response = await fetch(this.nextUrl);
        if (!response.ok) throw new Error('Failed to load blog page: ' + response.status);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll(
          '[data-blog-grid] > .piyonna-blog-article-list-section__item'
        );
        newItems.forEach((item) => {
          const img = item.querySelector('img');
          if (img) img.setAttribute('loading', 'lazy');
          this.grid.appendChild(document.importNode(item, true));
        });

        const nextLink = doc.querySelector('[data-next-url]');
        this.nextUrl = nextLink ? nextLink.getAttribute('href') : null;

        if (!this.nextUrl) this.finish();
      } catch (error) {
        console.error(error);
        this.finish();
      } finally {
        this.isLoading = false;
        if (this.loader) this.loader.hidden = true;
      }
    }

    finish() {
      if (this.observer) this.observer.disconnect();
      if (this.sentinel) this.sentinel.remove();
      if (this.loader) this.loader.remove();
      this.nextUrl = null;
    }
  }

  if (typeof customElements.get('piyonna-blog-article-list-component') === 'undefined') {
    customElements.define('piyonna-blog-article-list-component', PiyonnaBlogArticleListComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-brand-wall"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaBrandWallComponent extends HTMLElement {
    connectedCallback() {
      // 그리드 (>=768)
      this.grid = this.querySelector('.piyonna-brand-wall-section__grid');
      this.gridItems = this.grid ? Array.from(this.grid.children) : [];
      this._onResize = this.trimGrid.bind(this);
      window.addEventListener('resize', this._onResize);
      this.trimGrid();

      // 모바일 마키 (<768): rows 가 있을 때만 (12개 이상)
      this.rows = this.querySelector('.piyonna-brand-wall-section__rows');
      this.tracks = Array.from(this.querySelectorAll('.piyonna-brand-wall-section__track'));
      this.setWidth = parseFloat(this.dataset.setWidth) || 0;
      this.speed = parseFloat(this.dataset.speed) || 35; // px/s
      this.offset = 0;
      this.dragging = false;
      this.startX = 0;
      this.startOffset = 0;
      this.lastTs = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.rows || this.tracks.length === 0 || this.setWidth <= 0) return;

      this._onDown = this.onDown.bind(this);
      this._onMove = this.onMove.bind(this);
      this._onUp = this.onUp.bind(this);
      this._tick = this.tick.bind(this);

      this.rows.addEventListener('pointerdown', this._onDown);
      this.raf = requestAnimationFrame(this._tick);
    }

    // 현재 열 수(C) 기준으로 완전한 행(최대 5행)만 노출, 나머지 숨김
    trimGrid() {
      if (!this.grid || this.gridItems.length === 0) return;
      const cs = window.getComputedStyle(this.grid);
      if (cs.display === 'none') return; // 마키 모드(<768)에서는 그리드 숨김 상태라 스킵
      const cols = cs.gridTemplateColumns.split(' ').filter(Boolean).length;
      if (cols < 1) return;
      const total = this.gridItems.length;
      const rows = Math.min(5, Math.floor(total / cols));
      const shown = rows * cols;
      for (let i = 0; i < total; i++) {
        this.gridItems[i].style.display = i < shown ? '' : 'none';
      }
    }

    apply() {
      let o = this.offset % this.setWidth;
      if (o < 0) o += this.setWidth;
      const transform = 'translateX(' + -o + 'px)';
      for (let i = 0; i < this.tracks.length; i++) {
        this.tracks[i].style.transform = transform;
      }
    }

    tick(ts) {
      if (this.lastTs === null) this.lastTs = ts;
      const dt = (ts - this.lastTs) / 1000;
      this.lastTs = ts;
      // 마키가 숨겨진(>=768 그리드 모드) 동안은 갱신 스킵
      const hidden = this.rows.offsetParent === null;
      if (!hidden) {
        // 드래그 중이 아니고 모션 최소화가 아니면 자동 진행 (우 -> 좌)
        if (!this.dragging && !this.reduceMotion) {
          this.offset += this.speed * dt;
        }
        this.apply(); // 드래그 중에도 반영되도록 항상 적용
      }
      this.raf = requestAnimationFrame(this._tick);
    }

    onDown(e) {
      this.dragging = true;
      this.startX = e.clientX;
      this.startOffset = this.offset;
      if (this.rows.setPointerCapture) {
        try {
          this.rows.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      window.addEventListener('pointermove', this._onMove);
      window.addEventListener('pointerup', this._onUp);
      window.addEventListener('pointercancel', this._onUp);
    }

    onMove(e) {
      if (!this.dragging) return;
      // 오른쪽으로 끌면 콘텐츠가 오른쪽으로 (offset 감소)
      this.offset = this.startOffset - (e.clientX - this.startX);
    }

    onUp() {
      // 손을 떼면 즉시 자동 스크롤 재개 (관성 없음)
      this.dragging = false;
      window.removeEventListener('pointermove', this._onMove);
      window.removeEventListener('pointerup', this._onUp);
      window.removeEventListener('pointercancel', this._onUp);
    }

    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this.rows && this._onDown) this.rows.removeEventListener('pointerdown', this._onDown);
      if (this._onMove) window.removeEventListener('pointermove', this._onMove);
      if (this._onUp) {
        window.removeEventListener('pointerup', this._onUp);
        window.removeEventListener('pointercancel', this._onUp);
      }
    }
  }

  if (typeof customElements.get('piyonna-brand-wall-component') === 'undefined') {
    customElements.define('piyonna-brand-wall-component', PiyonnaBrandWallComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-footer-community"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KLAVIYO_PUBLIC_KEY = 'Rgku2X';
    const KLAVIYO_LIST_ID = 'X9YUF8';

    function getSectionTrackingId(el) {
      const wrapper = el?.closest('.piyonna-footer-community-wrapper');
      return wrapper?.dataset.sectionTrackingId || '';
    }

    function track(event, props) {
      if (window.GBTrack && typeof window.GBTrack.track === 'function') {
        window.GBTrack.track(event, props);
      }
    }

    async function subscribeToKlaviyo(email) {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_PUBLIC_KEY}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email },
                },
              },
              custom_source: 'PIYONNA Teasing Page',
            },
            relationships: {
              list: {
                data: { type: 'list', id: KLAVIYO_LIST_ID },
              },
            },
          },
        }),
      });
      return response.ok;
    }

    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function initKlaviyoForm() {
      const forms = document.querySelectorAll('[data-piyonna-klaviyo-form]');
      forms.forEach((form) => {
        const emailInput = form.querySelector('[data-piyonna-klaviyo-email]');
        const btn = form.querySelector('button[type="submit"]');
        if (!emailInput || !btn) return;

        const msgSuccess = form.dataset.alertSuccess;
        const msgFail = form.dataset.alertFail;
        const msgError = form.dataset.alertError;

        const disclaimerEl = form
          .closest('.piyonna-footer-community-left')
          ?.querySelector('[data-piyonna-klaviyo-disclaimer]');
        const originalDisclaimerHTML = disclaimerEl?.innerHTML || '';
        const msgInvalidEmail =
          form.dataset.alertInvalidEmail || 'Please enter a valid email address without spaces. (username@domain.com)';
        const errorIcon =
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0;"><circle cx="10" cy="10" r="10" fill="#D32F2F"/><text x="10" y="14.5" text-anchor="middle" fill="white" font-size="13" font-weight="bold">!</text></svg>';

        // Set initial disabled state
        btn.disabled = emailInput.value.trim().length === 0;

        emailInput.addEventListener('input', () => {
          btn.disabled = emailInput.value.trim().length === 0;
          // Restore original disclaimer when user types again
          if (disclaimerEl && disclaimerEl.classList.contains('is-error')) {
            disclaimerEl.innerHTML = originalDisclaimerHTML;
            disclaimerEl.classList.remove('is-error');
            disclaimerEl.style.color = '';
            disclaimerEl.style.display = '';
          }
        });

        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const trackingId = getSectionTrackingId(form);
          const email = emailInput.value.trim();
          if (!email) return;

          // Show inline error if email format is invalid
          if (!EMAIL_REGEX.test(email)) {
            track('footer_email_signup_invalid', { tracking_id: trackingId });
            if (disclaimerEl) {
              disclaimerEl.innerHTML = errorIcon + '<span>' + msgInvalidEmail + '</span>';
              disclaimerEl.classList.add('is-error');
              disclaimerEl.style.color = '#D32F2F';
              disclaimerEl.style.display = 'flex';
              disclaimerEl.style.alignItems = 'flex-start';
              disclaimerEl.style.gap = '8px';
            }
            return;
          }

          btn.disabled = true;

          try {
            const ok = await subscribeToKlaviyo(email);
            track('footer_email_signup_submit', { tracking_id: trackingId, success: !!ok });
            if (ok) {
              const formWrapper = form.closest('.email-form-wrapper');
              if (formWrapper) formWrapper.classList.add('hidden');
              const descEl = form
                .closest('.piyonna-footer-community-left')
                ?.querySelector('[data-piyonna-community-description]');
              if (descEl && descEl.dataset.successText) {
                descEl.textContent = descEl.dataset.successText;
              }
            } else {
              window.alert(msgFail);
              btn.disabled = false;
            }
          } catch {
            track('footer_email_signup_submit', { tracking_id: trackingId, success: false });
            window.alert(msgError);
            btn.disabled = false;
          }
        });
      });
    }

    function initPiyonnaFooterMenu() {
      const toggleBtns = document.querySelectorAll('[data-piyonna-footer-menu-toggle]');

      toggleBtns.forEach((btn) => {
        const groupEl = btn.closest('.piyonna-footer-community-menu, .piyonna-footer-community-follow');
        const content = groupEl?.querySelector('[data-piyonna-footer-menu-content]');
        if (!content) return;

        btn.addEventListener('click', () => {
          const isOpen = content.classList.contains('is-open');

          if (isOpen) {
            content.classList.remove('is-open');
            content.setAttribute('aria-hidden', 'true');
            btn.setAttribute('aria-expanded', 'false');
          } else {
            content.classList.add('is-open');
            content.setAttribute('aria-hidden', 'false');
            btn.setAttribute('aria-expanded', 'true');
          }

          track('footer_menu_toggle_click', {
            tracking_id: getSectionTrackingId(btn),
            menu_group: groupEl?.dataset.piyonnaFooterMenuGroup || 'unknown',
            expanded: !isOpen,
          });
        });
      });
    }

    function initTrustpilotBadge() {
      const badge = document.querySelector('[data-piyonna-trustpilot]');
      if (!badge) return;

      // FP-1164: raw dataLayer.push 는 게이팅 5계층을 전부 우회한다. GBTrack 경유로 통일.
      // GTM 어댑터가 이벤트명을 그대로 push 하므로 trustpilot_footer_click 트리거는 유지된다.
      badge.addEventListener('click', () => {
        track('trustpilot_footer_click', {
          tracking_id: getSectionTrackingId(badge),
          link_url: badge.href,
        });
      });

      const locale = badge.dataset.tpLocale || 'en-US';
      const url =
        'https://widget.trustpilot.com/trustbox-data/5419b637fa0340045cd0c936' +
        '?businessUnitId=6a0539f3fbae244c1337faee&locale=' +
        encodeURIComponent(locale);

      function fetchTrustScore() {
        fetch(url)
          .then((r) => (r.ok ? r.json() : null))
          .then((data) => {
            const score = data?.businessUnit?.trustScore;
            if (typeof score !== 'number') return;
            const labelEl = badge.querySelector('[data-tp-label]');
            const scoreEl = badge.querySelector('[data-tp-score]');
            if (data.starsString && labelEl) labelEl.textContent = data.starsString;
            if (scoreEl) scoreEl.textContent = score.toLocaleString(locale) + ' ' + badge.dataset.tpSuffix;
          })
          .catch(() => {});
      }

      // FP-1164: 3rd-party 요청이라 동의 전에는 보내지 않는다. 미동의 시에는 Liquid 이 렌더한
      // 기본값(별점·점수)이 그대로 남으므로 배지 자체는 정상 표시된다.
      // GBConsent 가 없는 레이아웃에서는 fail-closed — 요청하지 않는다 (CONSENT.md §5).
      if (window.GBConsent && typeof window.GBConsent.whenAllowed === 'function') {
        window.GBConsent.whenAllowed('analytics', fetchTrustScore);
      }
    }

    function init() {
      initKlaviyoForm();
      initPiyonnaFooterMenu();
      initTrustpilotBadge();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-footer-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function getSectionTrackingId(el) {
      const wrapper = el?.closest('.piyonna-footer-contact-wrapper');
      return wrapper?.dataset.sectionTrackingId || '';
    }

    function track(event, props) {
      if (window.GBTrack && typeof window.GBTrack.track === 'function') {
        window.GBTrack.track(event, props);
      }
    }

    function initPiyonnaFooterContact() {
      const toggleBtns = document.querySelectorAll('[data-piyonna-footer-contact-toggle]');

      toggleBtns.forEach((btn) => {
        const wrapper = btn.closest('.piyonna-footer-contact-inner');
        const content = wrapper?.querySelector('[data-piyonna-footer-contact-content]');
        if (!content) return;

        btn.addEventListener('click', () => {
          const isOpen = content.classList.contains('is-open');

          if (isOpen) {
            content.classList.remove('is-open');
            content.setAttribute('aria-hidden', 'true');
            btn.setAttribute('aria-expanded', 'false');
          } else {
            content.classList.add('is-open');
            content.setAttribute('aria-hidden', 'false');
            btn.setAttribute('aria-expanded', 'true');
          }

          track('footer_contact_toggle_click', {
            tracking_id: getSectionTrackingId(btn),
            expanded: !isOpen,
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPiyonnaFooterContact);
    } else {
      initPiyonnaFooterContact();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-home-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaHomeBannerCarouselComponent extends HTMLElement {
    connectedCallback() {
      var section = this.closest('.piyonna-home-banner-carousel-section');
      if (!section) return;

      this.scrollTarget = this.closest('.piyonna-home-banner-carousel');
      this.prevBtn = section.querySelector('.piyonna-home-banner__nav--prev');
      this.nextBtn = section.querySelector('.piyonna-home-banner__nav--next');
      this.leftGrad = section.querySelector('.piyonna-home-banner__gradient--left');
      this.rightGrad = section.querySelector('.piyonna-home-banner__gradient--right');

      if (!this.scrollTarget) return;

      var self = this;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.scroll('prev');
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.scroll('next');
        });
      }

      this.scrollTarget.addEventListener(
        'scroll',
        function () {
          self.updateNav();
        },
        { passive: true }
      );

      requestAnimationFrame(function () {
        self.updateNav();
      });

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(function () {
          self.updateNav();
        });
        this.resizeObserver.observe(this.scrollTarget);
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    scroll(direction) {
      var amount = this.scrollTarget.offsetWidth - 128;
      this.scrollTarget.scrollBy({
        left: direction === 'next' ? amount : -amount,
        behavior: 'smooth',
      });
    }

    updateNav() {
      if (!this.prevBtn || !this.nextBtn || !this.scrollTarget) return;

      var sl = this.scrollTarget.scrollLeft;
      var sw = this.scrollTarget.scrollWidth;
      var cw = this.scrollTarget.clientWidth;

      var atStart = sl <= 0;
      var atEnd = sl + cw >= sw - 1;

      this.prevBtn.classList.toggle('piyonna-home-banner__nav--hidden', atStart);
      this.nextBtn.classList.toggle('piyonna-home-banner__nav--hidden', atEnd);
      if (this.leftGrad) this.leftGrad.classList.toggle('piyonna-home-banner__gradient--hidden', atStart);
      if (this.rightGrad) this.rightGrad.classList.toggle('piyonna-home-banner__gradient--hidden', atEnd);
    }
  }

  if (typeof customElements.get('piyonna-home-banner-carousel-component') === 'undefined') {
    customElements.define('piyonna-home-banner-carousel-component', PiyonnaHomeBannerCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-home-video-card"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaHomeVideoCardComponent extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.piyonna-home-video-card__video');
      if (!this.video) return;

      // 태블릿·데스크탑(display:none)에서는 관찰·재생 스킵
      if (getComputedStyle(this).display === 'none') return;

      // 자동재생을 위해 음소거 + 인라인 재생 강제
      this.video.muted = true;
      this.video.setAttribute('playsinline', '');

      this.soundButton = this.querySelector('.piyonna-home-video-card__sound');
      this.mutedIcon = this.querySelector('.piyonna-home-video-card__sound-icon--muted');
      this.unmutedIcon = this.querySelector('.piyonna-home-video-card__sound-icon--unmuted');
      if (this.soundButton) {
        this.onSoundClick = this.onSoundClick.bind(this);
        this.soundButton.addEventListener('click', this.onSoundClick);
      }
      this.updateSoundUI();

      // 화면에 가까워지면 소스 주입(1회). 재생 observer 와 분리한 이유는
      // rootMargin 을 재생 판정에까지 적용하면 재생 시작 시점이 앞당겨지기 때문이다.
      this.loadObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.loadSources();
            this.loadObserver.disconnect();
          }
        },
        { rootMargin: '200px 0px', threshold: 0 }
      );
      this.loadObserver.observe(this.video);

      // 화면에 보일 때만 재생, 벗어나면 일시정지
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // rootMargin 없이 도달한 경우(빠른 스크롤 등) 대비 — 이미 로드됐으면 no-op
              this.loadSources();
              const played = this.video.play();
              if (played && typeof played.catch === 'function') {
                played.catch(() => {});
              }
            } else {
              this.video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this.video);
    }

    // <source data-src> → src 로 승격 후 1회만 load(). 중복 호출은 무시된다.
    loadSources() {
      if (this.sourcesLoaded) return;
      const sources = this.video.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      this.sourcesLoaded = true;
      sources.forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      this.video.load();
    }

    onSoundClick() {
      this.video.muted = !this.video.muted;
      this.updateSoundUI();
    }

    // muted 상태에 따라 아이콘 토글 (muted → sound-off, unmuted → sound-on)
    updateSoundUI() {
      const muted = this.video.muted;
      if (this.mutedIcon && this.unmutedIcon) {
        this.mutedIcon.classList.toggle('hidden', !muted);
        this.unmutedIcon.classList.toggle('hidden', muted);
      }
      if (this.soundButton) {
        this.soundButton.setAttribute('aria-pressed', String(muted === false));
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.loadObserver) {
        this.loadObserver.disconnect();
      }
      if (this.soundButton && this.onSoundClick) {
        this.soundButton.removeEventListener('click', this.onSoundClick);
      }
    }
  }

  if (typeof customElements.get('piyonna-home-video-card-component') === 'undefined') {
    customElements.define('piyonna-home-video-card-component', PiyonnaHomeVideoCardComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-membership-cta"]) return;
  try {
    
  // 고정 구간에서 바가 가리는 만큼 흐름에 자리를 남긴다. 줄바꿈으로 높이가 변하므로 실측한다.
  class PiyonnaMembershipCta extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.piyonna-membership-cta__bar');
      if (!this.bar) {
        return;
      }
      this.sync = this.sync.bind(this);
      if (typeof window.ResizeObserver === 'function') {
        this.observer = new ResizeObserver(this.sync);
        this.observer.observe(this.bar);
      } else {
        this.usesWindowFallback = true;
        window.addEventListener('resize', this.sync);
        window.addEventListener('load', this.sync);
      }
      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      } else if (this.usesWindowFallback) {
        window.removeEventListener('resize', this.sync);
        window.removeEventListener('load', this.sync);
      }
    }

    sync() {
      // 고정이 풀린 구간(>=1024)에서는 스페이서가 숨겨지므로 값이 남아 있어도 무해하다.
      this.style.setProperty('--membership-cta-height', this.bar.offsetHeight + 'px');
    }
  }

  if (!customElements.get('piyonna-membership-cta-component')) {
    customElements.define('piyonna-membership-cta-component', PiyonnaMembershipCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-mypage"]) return;
  try {
    
  class PiyonnaMypageComponent extends HTMLElement {
    connectedCallback() {
      // 국가/언어 행: 전용 전체화면 드로어(snippets/piyonna-country-language-drawer)를 연다.
      this.localeButton = this.querySelector('[data-piyonna-mypage-localization]');
      if (this.localeButton) {
        this.handleLocale = () => {
          if (typeof window.openPiyonnaCountryLanguageDrawer === 'function') {
            window.openPiyonnaCountryLanguageDrawer();
          }
        };
        this.localeButton.addEventListener('click', this.handleLocale);
      }

      // Beta / Production 전환: 현재 경로를 유지한 채 preview_theme_id 만 바꿔 재진입한다.
      this.themeToggleButton = this.querySelector('[data-piyonna-mypage-theme-toggle]');
      if (this.themeToggleButton) {
        this.handleThemeToggle = () => {
          const targetThemeId = this.themeToggleButton.dataset.piyonnaMypageThemeToggle;
          if (!targetThemeId) return;
          const url = new URL(window.location.href);
          url.searchParams.set('preview_theme_id', targetThemeId);
          // 프리뷰 진입 파라미터 — _sc 가 프리뷰 쿠키를 세팅해 이후 이동에도 테마가 유지된다.
          url.searchParams.set('_ab', '0');
          url.searchParams.set('_fd', '0');
          url.searchParams.set('_sc', '1');
          window.location.assign(url.toString());
        };
        this.themeToggleButton.addEventListener('click', this.handleThemeToggle);
      }

      // 크레딧 행: 안내 시트(snippets/piyonna-credit-sheet)를 연다.
      // 국가/언어 행과 같은 형태다 — 시트가 자기 열기 함수를 전역에 심어 두고, 여기서는 부른다.
      this.creditButton = this.querySelector('[data-piyonna-mypage-credit-info]');
      if (this.creditButton) {
        this.handleCredit = () => {
          if (typeof window.openPiyonnaCreditSheet === 'function') {
            window.openPiyonnaCreditSheet();
          }
        };
        this.creditButton.addEventListener('click', this.handleCredit);
      }

      // Log in / Sign up: 이동이 느린 지면이라 탭 즉시 전체화면 로딩을 띄운다.
      this.setupLoadingOverlay();
    }

    // 로딩 오버레이 배선. 오버레이 자체는 공용 스니펫(snippets/loading-overlay.liquid)이
    // layout/theme.liquid 에서 한 번 렌더한다. 여기는 트리거만 연결한다.
    setupLoadingOverlay() {
      const trigger = this.querySelector('[data-piyonna-mypage-loading-trigger]');
      if (!trigger || typeof window.showLoadingOverlay !== 'function') return;

      this.loadingTrigger = trigger;

      // preventDefault 를 하지 않는다 — 이동은 링크 기본동작이 그대로 처리한다.
      // 이동이 취소되면(예: 응답 대기 중 뒤로가기) 닫으라는 신호가 오지 않으므로
      // 오버레이의 안전장치 시간에 맡긴다. bfcache 복원은 오버레이가 pageshow 로 처리한다.
      this.handleLoadingOpen = () => window.showLoadingOverlay();
      trigger.addEventListener('click', this.handleLoadingOpen);
    }

    disconnectedCallback() {
      if (this.localeButton && this.handleLocale) {
        this.localeButton.removeEventListener('click', this.handleLocale);
      }
      if (this.themeToggleButton && this.handleThemeToggle) {
        this.themeToggleButton.removeEventListener('click', this.handleThemeToggle);
      }

      if (this.creditButton && this.handleCredit) {
        this.creditButton.removeEventListener('click', this.handleCredit);
      }

      // 로딩 오버레이: 트리거 리스너만 걷는다. 오버레이 자체(타이머·lottie 인스턴스)는
      // 공용 스니펫이 소유하므로 여기서 건드리지 않는다.
      // (테마 에디터에서 섹션을 재렌더하면 connectedCallback 이 다시 돈다)
      if (this.loadingTrigger && this.handleLoadingOpen) {
        this.loadingTrigger.removeEventListener('click', this.handleLoadingOpen);
      }
    }
  }

  if (typeof customElements.get('piyonna-mypage-component') === 'undefined') {
    customElements.define('piyonna-mypage-component', PiyonnaMypageComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaProductCarouselComponent extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('.piyonna-product-carousel__container');
      this.prevBtn = this.querySelector('.piyonna-product-carousel__nav--prev');
      this.nextBtn = this.querySelector('.piyonna-product-carousel__nav--next');

      this.applyExternalLinkOrder();
      this.sortSlides();

      if (!this.container) return;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scroll('prev'));
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scroll('next'));
      }

      this.container.addEventListener('scroll', () => this.updateNavVisibility());

      this.updateNavVisibility();

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.updateNavVisibility());
        this.resizeObserver.observe(this.container);
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    applyExternalLinkOrder() {
      if (window.innerWidth >= 768) return;

      var params = new URLSearchParams(window.location.search);
      if (params.get('is_external_link') !== 'true') return;

      var orderValue = this.dataset.externalLinkOrder;
      if (orderValue === '' || orderValue == null) return;

      var sectionEl = this.closest('.shopify-section');
      if (!sectionEl) return;

      sectionEl.style.order = orderValue;
    }

    sortSlides() {
      var sortBy = this.dataset.sortBy;
      if (!sortBy || sortBy === 'default' || sortBy === 'collection_order') return;

      var track = this.querySelector('.piyonna-product-carousel__track');
      if (!track) return;

      var slides = Array.from(
        track.querySelectorAll('.piyonna-product-carousel__slide:not(.piyonna-product-carousel__placeholder)')
      );
      if (slides.length <= 1) return;

      if (sortBy === 'random') {
        for (var i = slides.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var temp = slides[i];
          slides[i] = slides[j];
          slides[j] = temp;
        }
      } else {
        slides.sort(function (a, b) {
          if (sortBy === 'review_count') {
            return (parseInt(b.dataset.reviewCount) || 0) - (parseInt(a.dataset.reviewCount) || 0);
          } else if (sortBy === 'price_desc') {
            return (parseInt(b.dataset.price) || 0) - (parseInt(a.dataset.price) || 0);
          } else if (sortBy === 'price_asc') {
            return (parseInt(a.dataset.price) || 0) - (parseInt(b.dataset.price) || 0);
          }
          return 0;
        });
      }

      slides.forEach(function (slide) {
        track.appendChild(slide);
      });

      // DOM 정렬 후 index를 표시 순서로 동기화
      track.querySelectorAll('.piyonna-product-carousel__slide').forEach(function (slide, i) {
        ['data-gb-props-view', 'data-gb-props-click'].forEach(function (attr) {
          var raw = slide.getAttribute(attr);
          if (!raw) return;
          try {
            var obj = JSON.parse(raw);
            obj.index = i + 1;
            slide.setAttribute(attr, JSON.stringify(obj));
          } catch (e) {}
        });
      });
    }

    scroll(direction) {
      const cs = this.container;
      if (!cs) return;
      const slides = Array.from(this.querySelectorAll('.piyonna-product-carousel__slide'));
      if (!slides.length) return;

      const csRect = cs.getBoundingClientRect();
      const style = getComputedStyle(cs);
      const padLeft = parseFloat(style.paddingLeft) || 0;
      const padRight = parseFloat(style.paddingRight) || 0;
      const leftEdge = csRect.left + padLeft;
      const rightEdge = csRect.right - padRight;
      const TOL = 1;

      if (direction === 'next') {
        // 오른쪽으로 완전히 가려져 있던 '다음' 상품을 맨 왼쪽으로 정렬
        const target = slides.find((s) => s.getBoundingClientRect().left >= rightEdge - TOL);
        if (target) {
          cs.scrollBy({ left: target.getBoundingClientRect().left - leftEdge, behavior: 'smooth' });
        } else {
          cs.scrollTo({ left: cs.scrollWidth, behavior: 'smooth' });
        }
      } else {
        // 왼쪽으로 완전히 가려진 마지막 상품을 맨 오른쪽에 맞춰 한 페이지 뒤로
        const hidden = slides.filter((s) => s.getBoundingClientRect().right <= leftEdge + TOL);
        const target = hidden[hidden.length - 1];
        if (target) {
          cs.scrollBy({ left: target.getBoundingClientRect().right - rightEdge, behavior: 'smooth' });
        } else {
          cs.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }

    updateNavVisibility() {
      if (!this.prevBtn || !this.nextBtn) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.container;
      const atStart = scrollLeft <= 0;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      this.prevBtn.classList.toggle('piyonna-product-carousel__nav--hidden', atStart);
      this.nextBtn.classList.toggle('piyonna-product-carousel__nav--hidden', atEnd);

      var leftGrad = this.querySelector('.piyonna-product-carousel__gradient--left');
      var rightGrad = this.querySelector('.piyonna-product-carousel__gradient--right');
      if (leftGrad) leftGrad.classList.toggle('piyonna-product-carousel__gradient--hidden', atStart);
      if (rightGrad) rightGrad.classList.toggle('piyonna-product-carousel__gradient--hidden', atEnd);
    }
  }

  if (typeof customElements.get('piyonna-product-carousel-component') === 'undefined') {
    customElements.define('piyonna-product-carousel-component', PiyonnaProductCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-product-grid"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaProductGridComponent extends HTMLElement {
    // sentinel 이 뷰포트에서 이만큼 떨어져 있으면 미리 로딩한다.
    // 모바일 뷰포트(약 800px) 1.5 화면 앞에서 당겨오는 값 — 스크롤이 빨라도 빈 화면을 안 만나도록.
    static AUTO_LOAD_MARGIN = 1200;

    connectedCallback() {
      this.perPage = parseInt(this.dataset.perPage, 10) || 24;
      this.loadType = this.dataset.loadType || 'button';
      this.sectionId = this.dataset.sectionId || '';

      this.grid = this.querySelector('[data-grid]');
      this.sentinel = this.querySelector('[data-sentinel]');
      this.button = this.querySelector('[data-load-more]');
      this.loader = this.querySelector('[data-loader]');

      const nextLink = this.querySelector('[data-next-url]');
      this.nextUrl = nextLink ? nextLink.getAttribute('href') : null;

      // 수동 선택 상품은 서버가 전부 렌더한 뒤 초과분을 감춰둔다 → 순차 노출
      this.hiddenItems = this.grid
        ? Array.from(this.grid.querySelectorAll(':scope > .piyonna-product-grid__item[hidden]'))
        : [];

      this.isLoading = false;
      this.isPumping = false;

      if (!this.grid || !this.hasMore()) {
        this.finish();
        return;
      }

      if (this.loadType === 'auto' && this.sentinel && 'IntersectionObserver' in window) {
        this.initAutoLoad();
      } else {
        this.initButtonLoad();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    hasMore() {
      return this.hiddenItems.length > 0 || !!this.nextUrl;
    }

    initAutoLoad() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.pump();
        },
        { rootMargin: PiyonnaProductGridComponent.AUTO_LOAD_MARGIN + 'px 0px' }
      );
      this.observer.observe(this.sentinel);

      // 첫 렌더에서 sentinel 이 이미 화면 안이면 콜백이 한 번만 오므로 직접 펌프
      this.pump();
    }

    initButtonLoad() {
      // auto 지만 IntersectionObserver 가 없는 환경이면 버튼이 없다 → 이 경우는 그대로 종료
      if (!this.button) return;
      this.button.addEventListener('click', () => this.loadNext());
    }

    /**
     * IntersectionObserver 는 "교차 상태가 바뀔 때"만 콜백한다.
     * 배치를 붙여도 sentinel 이 여전히 화면 근처에 남아 있으면 다시 발사되지 않고,
     * 사용자가 이미 페이지 끝이라 더 스크롤할 수 없으면 로딩이 그대로 멈춘다.
     * → sentinel 이 감시 영역 밖으로 밀려날 때까지 직접 반복한다.
     */
    async pump() {
      if (this.isPumping) return;
      this.isPumping = true;
      try {
        while (this.hasMore() && this.isSentinelNear()) {
          const before = this.progressSignature();
          await this.loadNext();
          // 아무것도 늘지 않았으면(응답이 비었거나 실패) 무한 루프를 막는다
          if (this.progressSignature() === before) break;
        }
      } finally {
        this.isPumping = false;
      }
    }

    progressSignature() {
      return this.hiddenItems.length + ':' + this.grid.children.length + ':' + (this.nextUrl || '');
    }

    isSentinelNear() {
      if (!this.sentinel || !this.sentinel.isConnected) return false;
      const margin = PiyonnaProductGridComponent.AUTO_LOAD_MARGIN;
      const rect = this.sentinel.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      return rect.top <= viewportHeight + margin && rect.bottom >= -margin;
    }

    async loadNext() {
      if (this.isLoading || !this.hasMore()) return;
      this.isLoading = true;

      try {
        if (this.hiddenItems.length > 0) {
          this.revealNextBatch();
        } else {
          this.setLoading(true);
          await this.fetchNextPage();
        }
      } catch (error) {
        console.error('[piyonna-product-grid] 추가 로딩 실패', error);
        this.nextUrl = null;
      } finally {
        this.isLoading = false;
        this.setLoading(false);
        if (!this.hasMore()) this.finish();
      }
    }

    revealNextBatch() {
      this.hiddenItems.splice(0, this.perPage).forEach((item) => item.removeAttribute('hidden'));
    }

    async fetchNextPage() {
      const response = await fetch(this.buildSectionUrl(this.nextUrl));
      if (!response.ok) throw new Error('추가 페이지 응답 오류: ' + response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const newItems = doc.querySelectorAll('[data-grid] > .piyonna-product-grid__item');

      newItems.forEach((item) => {
        const imported = document.importNode(item, true);
        imported.removeAttribute('hidden');
        const img = imported.querySelector('img');
        if (img) img.setAttribute('loading', 'lazy');
        this.grid.appendChild(imported);
      });

      const nextLink = doc.querySelector('[data-next-url]');
      this.nextUrl = newItems.length && nextLink ? nextLink.getAttribute('href') : null;
    }

    /** paginate.next.url 에 section_id 를 붙여 Section Rendering API 로 요청한다. */
    buildSectionUrl(href) {
      const url = new URL(href, window.location.origin);
      if (this.sectionId) url.searchParams.set('section_id', this.sectionId);
      return url.toString();
    }

    setLoading(isLoading) {
      if (this.loader) this.loader.hidden = !isLoading;
      if (this.button) this.button.disabled = isLoading;
    }

    finish() {
      if (this.observer) this.observer.disconnect();

      const wrapper = this.querySelector('[data-load-more-wrapper]');
      if (wrapper) wrapper.remove();
      if (this.sentinel) this.sentinel.remove();
      if (this.loader) this.loader.remove();

      const nextLink = this.querySelector('[data-next-url]');
      if (nextLink) nextLink.remove();

      this.nextUrl = null;
    }
  }

  if (typeof customElements.get('piyonna-product-grid-component') === 'undefined') {
    customElements.define('piyonna-product-grid-component', PiyonnaProductGridComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-promotion-guest-cta"] && !Shopify.designMode) return;
  try {
    
  // 고정 바가 가리는 만큼 흐름에 자리를 남긴다. 줄바꿈으로 높이가 변하므로 실측한다.
  class PiyonnaPromotionGuestCta extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.piyonna-promotion-guest-cta__bar');
      if (!this.bar) {
        return;
      }
      this.sync = this.sync.bind(this);
      if (typeof window.ResizeObserver === 'function') {
        this.observer = new ResizeObserver(this.sync);
        this.observer.observe(this.bar);
      } else {
        this.usesWindowFallback = true;
        window.addEventListener('resize', this.sync);
        window.addEventListener('load', this.sync);
      }
      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      } else if (this.usesWindowFallback) {
        window.removeEventListener('resize', this.sync);
        window.removeEventListener('load', this.sync);
      }
    }

    sync() {
      this.style.setProperty('--promotion-guest-cta-height', this.bar.offsetHeight + 'px');
    }
  }

  if (!customElements.get('piyonna-promotion-guest-cta-component')) {
    customElements.define('piyonna-promotion-guest-cta-component', PiyonnaPromotionGuestCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-promotion-lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaProductPick extends HTMLElement {
    connectedCallback() {
      const N = parseInt(this.dataset.blocksCount, 10) || 0;
      if (N === 0) return;
      this.N = N;
      this.trackingId = this.dataset.trackingId || '';
      this.slideEvent = this.dataset.slideEvent || '';
      this.wideMode = this.dataset.wideMode === 'true';
      this.lastFiredIdx = -1;
      this.mqDesktop = window.matchMedia('(min-width: 1025px)');
      this.mqTablet = window.matchMedia('(min-width: 750px)');
      this.track = this.querySelector('.piyonna-product-pick__image-track');
      this.slides = Array.from(this.querySelectorAll('.piyonna-product-pick__image-slide'));
      this.prevBtn = this.querySelector('.piyonna-product-pick__nav--prev');
      this.nextBtn = this.querySelector('.piyonna-product-pick__nav--next');
      this.indicator = this.querySelector('.piyonna-product-pick__indicator-current');
      this._initProductNav();
      if (!this.track) return;

      this._lock = 0;
      if (N > 1) {
        const fc = this.slides[0].cloneNode(true),
          lc = this.slides[N - 1].cloneNode(true);
        fc.removeAttribute('data-active');
        lc.removeAttribute('data-active');
        this.track.appendChild(fc);
        this.track.insertBefore(lc, this.slides[0]);
        this.idx = 1;
      } else {
        this.idx = 0;
      }
      this._jump();
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.idx - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.idx + 1));
      this.mqDesktop.addEventListener('change', () => this._jump());
      this.mqTablet.addEventListener('change', () => this._jump());

      let sx = 0,
        sy = 0,
        drag = false;
      this.track.addEventListener(
        'touchstart',
        (e) => {
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          drag = false;
        },
        { passive: true }
      );
      this.track.addEventListener(
        'touchmove',
        (e) => {
          const dx = e.touches[0].clientX - sx,
            dy = e.touches[0].clientY - sy;
          if (!drag && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) drag = true;
        },
        { passive: true }
      );
      this.track.addEventListener(
        'touchend',
        (e) => {
          if (!drag) return;
          const dx = e.changedTouches[0].clientX - sx;
          if (dx < -40) this.go(this.idx + 1);
          else if (dx > 40) this.go(this.idx - 1);
          drag = false;
        },
        { passive: true }
      );
      this._render();
    }

    _realIdx() {
      return this.N > 1 ? (((this.idx - 1) % this.N) + this.N) % this.N : this.idx;
    }

    _pos() {
      if (this.wideMode) return this.idx * 100;
      if (this.mqDesktop.matches) return (this.idx - 1) * 33.333;
      if (this.mqTablet.matches) return this.idx * 50 - 25;
      return this.idx * 100;
    }

    _jump() {
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${-this._pos()}%)`;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          this.track.style.transition = '';
        })
      );
    }

    go(i) {
      if (Date.now() < this._lock) return;
      this.idx = i;
      if (this.N > 1) {
        this._lock = Date.now() + 400;
        this.track.style.transform = `translateX(${-this._pos()}%)`;
        if (i === 0 || i === this.N + 1) {
          clearTimeout(this._wt);
          this._wt = setTimeout(() => {
            this.idx = i === 0 ? this.N : 1;
            this._jump();
          }, 360);
        }
      } else {
        this.idx = Math.max(0, Math.min(i, this.N - 1));
        this.track.style.transform = `translateX(${-this._pos()}%)`;
      }
      this._render();
    }

    _render() {
      const r = this._realIdx();
      this.slides.forEach((s, i) => s.toggleAttribute('data-active', i === r));
      if (this.indicator) this.indicator.textContent = r + 1;
      if (this.N > 1) {
        if (this.prevBtn) this.prevBtn.removeAttribute('data-hidden');
        if (this.nextBtn) this.nextBtn.removeAttribute('data-hidden');
      } else {
        if (this.prevBtn) this.prevBtn.toggleAttribute('data-hidden', this.idx <= 0);
        if (this.nextBtn) this.nextBtn.toggleAttribute('data-hidden', this.idx >= this.N - 1);
      }
      this._fireSlideImpression(r);
    }

    _initProductNav() {
      const container = this.querySelector('.piyonna-product-pick__product-container');
      if (!container) return;
      const prev = this.querySelector('.piyonna-product-pick__product-nav--prev');
      const next = this.querySelector('.piyonna-product-pick__product-nav--next');
      const leftGrad = this.querySelector('.piyonna-product-pick__product-gradient--left');
      const rightGrad = this.querySelector('.piyonna-product-pick__product-gradient--right');

      const update = () => {
        const { scrollLeft, scrollWidth, clientWidth } = container;
        if (scrollWidth <= clientWidth) {
          if (prev) prev.classList.add('piyonna-product-pick__product-nav--hidden');
          if (next) next.classList.add('piyonna-product-pick__product-nav--hidden');
          if (leftGrad) leftGrad.classList.add('piyonna-product-pick__product-gradient--hidden');
          if (rightGrad) rightGrad.classList.add('piyonna-product-pick__product-gradient--hidden');
          return;
        }
        const atStart = scrollLeft <= 0;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
        if (prev) prev.classList.toggle('piyonna-product-pick__product-nav--hidden', atStart);
        if (next) next.classList.toggle('piyonna-product-pick__product-nav--hidden', atEnd);
        if (leftGrad) leftGrad.classList.toggle('piyonna-product-pick__product-gradient--hidden', atStart);
        if (rightGrad) rightGrad.classList.toggle('piyonna-product-pick__product-gradient--hidden', atEnd);
      };

      const doScroll = (direction) => {
        const amount = container.offsetWidth * 0.8;
        const delta = direction === 'next' ? amount : -amount;
        container.scrollTo({ left: container.scrollLeft + delta, behavior: 'smooth' });
      };

      if (prev) {
        prev.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          doScroll('prev');
        });
      }
      if (next) {
        next.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          doScroll('next');
        });
      }
      container.addEventListener('scroll', update);
      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(update);
        ro.observe(container);
      }
      update();
    }

    _fireSlideImpression(r) {
      if (!this.slideEvent) return;
      if (r === this.lastFiredIdx) return;
      this.lastFiredIdx = r;
      if (!window.GBTrack || typeof window.GBTrack.track !== 'function') return;
      const slide = this.slides[r];
      const blockTrackingId = (slide && slide.dataset.blockTrackingId) || '';
      window.GBTrack.track(this.slideEvent, {
        tracking_id: this.trackingId,
        block_tracking_id: blockTrackingId,
        index: r + 1,
      });
    }
  }

  if (typeof customElements.get('piyonna-product-pick') === 'undefined') {
    customElements.define('piyonna-product-pick', PiyonnaProductPick);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-promotion-lookbook-image"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaProductPick extends HTMLElement {
    connectedCallback() {
      const N = parseInt(this.dataset.blocksCount, 10) || 0;
      if (N === 0) return;
      this.N = N;
      this.trackingId = this.dataset.trackingId || '';
      this.slideEvent = this.dataset.slideEvent || '';
      this.wideMode = this.dataset.wideMode === 'true';
      this.lastFiredIdx = -1;
      this.mqDesktop = window.matchMedia('(min-width: 1025px)');
      this.mqTablet = window.matchMedia('(min-width: 750px)');
      this.track = this.querySelector('.piyonna-product-pick__image-track');
      this.slides = Array.from(this.querySelectorAll('.piyonna-product-pick__image-slide'));
      this.prevBtn = this.querySelector('.piyonna-product-pick__nav--prev');
      this.nextBtn = this.querySelector('.piyonna-product-pick__nav--next');
      this.indicator = this.querySelector('.piyonna-product-pick__indicator-current');
      this.sets = Array.from(this.querySelectorAll('.piyonna-product-pick__product-set'));
      this._initProductNavs();
      if (!this.track) return;

      this._lock = 0;
      if (N > 1) {
        const fc = this.slides[0].cloneNode(true),
          lc = this.slides[N - 1].cloneNode(true);
        fc.removeAttribute('data-active');
        lc.removeAttribute('data-active');
        this.track.appendChild(fc);
        this.track.insertBefore(lc, this.slides[0]);
        this.idx = 1;
      } else {
        this.idx = 0;
      }
      this._jump();
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.idx - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.idx + 1));
      this.mqDesktop.addEventListener('change', () => this._jump());
      this.mqTablet.addEventListener('change', () => this._jump());

      let sx = 0,
        sy = 0,
        drag = false;
      this.track.addEventListener(
        'touchstart',
        (e) => {
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          drag = false;
        },
        { passive: true }
      );
      this.track.addEventListener(
        'touchmove',
        (e) => {
          const dx = e.touches[0].clientX - sx,
            dy = e.touches[0].clientY - sy;
          if (!drag && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) drag = true;
        },
        { passive: true }
      );
      this.track.addEventListener(
        'touchend',
        (e) => {
          if (!drag) return;
          const dx = e.changedTouches[0].clientX - sx;
          if (dx < -40) this.go(this.idx + 1);
          else if (dx > 40) this.go(this.idx - 1);
          drag = false;
        },
        { passive: true }
      );
      this._render();
    }

    _realIdx() {
      return this.N > 1 ? (((this.idx - 1) % this.N) + this.N) % this.N : this.idx;
    }

    _pos() {
      if (this.wideMode) return this.idx * 100;
      if (this.mqDesktop.matches) return (this.idx - 1) * 33.333;
      if (this.mqTablet.matches) return this.idx * 50 - 25;
      return this.idx * 100;
    }

    _jump() {
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${-this._pos()}%)`;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          this.track.style.transition = '';
        })
      );
    }

    go(i) {
      if (Date.now() < this._lock) return;
      this.idx = i;
      if (this.N > 1) {
        this._lock = Date.now() + 400;
        this.track.style.transform = `translateX(${-this._pos()}%)`;
        if (i === 0 || i === this.N + 1) {
          clearTimeout(this._wt);
          this._wt = setTimeout(() => {
            this.idx = i === 0 ? this.N : 1;
            this._jump();
          }, 360);
        }
      } else {
        this.idx = Math.max(0, Math.min(i, this.N - 1));
        this.track.style.transform = `translateX(${-this._pos()}%)`;
      }
      this._render();
    }

    _render() {
      const r = this._realIdx();
      this.slides.forEach((s, i) => s.toggleAttribute('data-active', i === r));
      if (this.indicator) this.indicator.textContent = r + 1;
      if (this.N > 1) {
        if (this.prevBtn) this.prevBtn.removeAttribute('data-hidden');
        if (this.nextBtn) this.nextBtn.removeAttribute('data-hidden');
      } else {
        if (this.prevBtn) this.prevBtn.toggleAttribute('data-hidden', this.idx <= 0);
        if (this.nextBtn) this.nextBtn.toggleAttribute('data-hidden', this.idx >= this.N - 1);
      }
      this.sets.forEach((s, j) => {
        s.style.display = j === r ? 'block' : 'none';
      });
      this._updateActiveProductNav(r);
      this._fireSlideImpression(r);
    }

    _initProductNavs() {
      this._productNavUpdaters = [];
      this.sets.forEach((set) => {
        const container = set.querySelector('.piyonna-product-pick__product-container');
        const prev = set.querySelector('.piyonna-product-pick__product-nav--prev');
        const next = set.querySelector('.piyonna-product-pick__product-nav--next');
        const leftGrad = set.querySelector('.piyonna-product-pick__product-gradient--left');
        const rightGrad = set.querySelector('.piyonna-product-pick__product-gradient--right');
        if (!container) {
          this._productNavUpdaters.push(null);
          return;
        }

        const update = () => {
          const { scrollLeft, scrollWidth, clientWidth } = container;
          if (scrollWidth <= clientWidth) {
            if (prev) prev.classList.add('piyonna-product-pick__product-nav--hidden');
            if (next) next.classList.add('piyonna-product-pick__product-nav--hidden');
            if (leftGrad) leftGrad.classList.add('piyonna-product-pick__product-gradient--hidden');
            if (rightGrad) rightGrad.classList.add('piyonna-product-pick__product-gradient--hidden');
            return;
          }
          const atStart = scrollLeft <= 0;
          const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
          if (prev) prev.classList.toggle('piyonna-product-pick__product-nav--hidden', atStart);
          if (next) next.classList.toggle('piyonna-product-pick__product-nav--hidden', atEnd);
          if (leftGrad) leftGrad.classList.toggle('piyonna-product-pick__product-gradient--hidden', atStart);
          if (rightGrad) rightGrad.classList.toggle('piyonna-product-pick__product-gradient--hidden', atEnd);
        };

        const doScroll = (direction) => {
          const amount = container.offsetWidth * 0.8;
          const delta = direction === 'next' ? amount : -amount;
          container.scrollTo({ left: container.scrollLeft + delta, behavior: 'smooth' });
        };

        if (prev) {
          prev.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            doScroll('prev');
          });
        }
        if (next) {
          next.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            doScroll('next');
          });
        }
        container.addEventListener('scroll', update);
        if (typeof ResizeObserver !== 'undefined') {
          const ro = new ResizeObserver(update);
          ro.observe(container);
        }
        update();
        this._productNavUpdaters.push(update);
      });
    }

    _updateActiveProductNav(r) {
      if (!this._productNavUpdaters) return;
      const updater = this._productNavUpdaters[r];
      if (updater) updater();
    }

    _fireSlideImpression(r) {
      if (!this.slideEvent) return;
      if (r === this.lastFiredIdx) return;
      this.lastFiredIdx = r;
      if (!window.GBTrack || typeof window.GBTrack.track !== 'function') return;
      const slide = this.slides[r];
      const blockTrackingId = (slide && slide.dataset.blockTrackingId) || '';
      window.GBTrack.track(this.slideEvent, {
        tracking_id: this.trackingId,
        block_tracking_id: blockTrackingId,
        index: r + 1,
      });
    }
  }

  if (typeof customElements.get('piyonna-product-pick') === 'undefined') {
    customElements.define('piyonna-product-pick', PiyonnaProductPick);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piyonna-trend-carousel"] && !Shopify.designMode) return;
  try {
    
  class PiyonnaTrendCarouselComponent extends HTMLElement {
    connectedCallback() {
      this.scrollContainer = this.querySelector('.piyonna-trend-carousel__scroll-container');
      this.cards = this.querySelectorAll('.piyonna-trend-carousel__card');
      this.panels = this.querySelectorAll('.piyonna-trend-carousel__panel');
      this.prevBtn = this.querySelector('.piyonna-trend-carousel__nav--prev');
      this.nextBtn = this.querySelector('.piyonna-trend-carousel__nav--next');

      this.cards.forEach((card) => {
        card.addEventListener('click', () => {
          const index = parseInt(card.dataset.index, 10);
          this.selectCard(index);
        });
      });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollCarousel('prev'));
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollCarousel('next'));
      }

      if (this.scrollContainer) {
        this.scrollContainer.addEventListener('scroll', () => this.updateNavVisibility());
      }

      this.selectCard(0);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.updateNavVisibility());
        if (this.scrollContainer) this.resizeObserver.observe(this.scrollContainer);
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    selectCard(index) {
      this.cards.forEach((card, i) => {
        const isActive = i === index;
        card.classList.toggle('piyonna-trend-carousel__card--active', isActive);
        card.setAttribute('aria-pressed', String(isActive));
      });

      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('piyonna-trend-carousel__panel--active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
    }

    scrollCarousel(direction) {
      if (!this.scrollContainer) return;
      const scrollAmount = this.scrollContainer.offsetWidth * 0.8;
      this.scrollContainer.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth',
      });
    }

    updateNavVisibility() {
      if (!this.prevBtn || !this.nextBtn || !this.scrollContainer) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
      const atStart = scrollLeft <= 0;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      this.prevBtn.style.display = atStart ? 'none' : '';
      this.nextBtn.style.display = atEnd ? 'none' : '';
    }
  }

  if (typeof customElements.get('piyonna-trend-carousel-component') === 'undefined') {
    customElements.define('piyonna-trend-carousel-component', PiyonnaTrendCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-settings-in-app"]) return;
  try {
    
  class PrivacySettingsInApp extends HTMLElement {
    connectedCallback() {
      this.toggles = Array.from(this.querySelectorAll('[data-privacy-settings-toggle]'));
      this.attNotice = this.querySelector('[data-privacy-settings-att-notice]');
      this.openSettingsButton = this.querySelector('[data-privacy-settings-open-app-settings]');

      // app-bridge.js 는 defer 라 이 스크립트보다 늦을 수 있다 — 없으면 파싱이 끝난 뒤 다시 본다
      if (window.PiyonnaApp) {
        this.init();
      } else {
        this.handleReady = () => this.init();
        document.addEventListener('DOMContentLoaded', this.handleReady, { once: true });
      }
    }

    init() {
      const app = window.PiyonnaApp;
      if (!app || this.initialized) return;
      this.initialized = true;

      // 주입값이 없으면 인앱 아님 · 구버전 앱 — 토글을 비활성으로 둔 채 끝낸다
      const consent = app.consent();
      if (!consent) return;

      this.render(consent);

      this.handleToggle = (event) => {
        const toggle = event.currentTarget;
        if (toggle.getAttribute('aria-disabled') === 'true') return;

        const key = toggle.dataset.privacySettingsToggle;
        const enabled = toggle.getAttribute('aria-checked') !== 'true';

        // 낙관적 갱신 — 유효한 값은 앱이 거부하지 않는다(규약 3.12)
        toggle.setAttribute('aria-checked', String(enabled));
        if (key === 'advertising') this.renderAttNotice(enabled);

        // 바뀐 키만 보낸다 — 전체 값을 보내면 다른 지면에서 바뀐 값을 덮어쓸 수 있다
        app.setConsent({ [key]: enabled });
      };
      this.toggles.forEach((toggle) => toggle.addEventListener('click', this.handleToggle));

      this.handleOpenSettings = () => app.openAppSettings();
      this.openSettingsButton?.addEventListener('click', this.handleOpenSettings);

      // 자기 요청의 확인 · 다른 지면 · 네이티브 팝업 변경 — 진입 때와 같은 렌더 함수로 받는다
      this.unsubscribeConsent = app.onConsentChange((next) => this.render(next));
      // 설정에서 추적 허용 후 복귀 → 안내 숨김
      this.unsubscribeAtt = app.onAttAuthorizedChange(() => {
        const current = app.consent();
        if (current) this.render(current);
      });
    }

    render(consent) {
      this.toggles.forEach((toggle) => {
        const key = toggle.dataset.privacySettingsToggle;
        toggle.setAttribute('aria-checked', String(consent[key] === true));
        toggle.removeAttribute('aria-disabled');
      });
      this.renderAttNotice(consent.advertising === true);
    }

    renderAttNotice(advertising) {
      if (!this.attNotice) return;
      const app = window.PiyonnaApp;
      // ⚠️ attAuthorized() !== true 로 판정한다 — 값이 빠진 iOS 를 허용으로 보지 않는다(규약 3.12 불변식)
      const show = advertising && app.isIOSApp() && app.attAuthorized() !== true;
      this.attNotice.hidden = !show;
    }

    disconnectedCallback() {
      if (this.handleReady) document.removeEventListener('DOMContentLoaded', this.handleReady);
      this.toggles?.forEach((toggle) => toggle.removeEventListener('click', this.handleToggle));
      this.openSettingsButton?.removeEventListener('click', this.handleOpenSettings);
      this.unsubscribeConsent?.();
      this.unsubscribeAtt?.();
    }
  }

  if (!customElements.get('privacy-settings-in-app')) {
    customElements.define('privacy-settings-in-app', PrivacySettingsInApp);
  }

  } catch(e) { console.error(e); }
})();
})();
